import { render, staticRenderFns } from "./ArrangeForServiceFlmInstructions.vue?vue&type=template&id=00b8ee08&scoped=true"
import script from "./ArrangeForServiceFlmInstructions.vue?vue&type=script&lang=ts"
export * from "./ArrangeForServiceFlmInstructions.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=00b8ee08&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8ee08",
  null
  
)

export default component.exports